// extracted by mini-css-extract-plugin
module.exports = {"pageHeaderBlock":"PageHeaderBlock_pageHeaderBlock__JxY0m","blockHeader":"PageHeaderBlock_blockHeader__43Def"};